import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    projects: {
        padding: "50px 20px",
        "& h1": {
            color: "#252E48",
            fontSize: "50px",
            marginBottom: "15px",
            textAlign: "center",
            transition: "opacity 0.5s ease-out, transform 0.5s ease-out",
            "@media only screen and (max-width: 550px)": {
                fontSize: "30px"
            }
        },
    },
    items: {
        position: "relative",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "80%",
        padding: "0px 30px",
        margin: "20px auto",
        opacity: 0,
        transform: "translateY(20px)",
        transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
        "@media only screen and (max-width: 1500px)": {
            width: "100%",
            flexDirection: "column"
        }
    },
    animateIn: {
        opacity: 1,
        transform: "translateY(0)",
    },
    animateOut: {
        opacity: 0,
        transform: "translateY(20px)",
    },
    txt: {
        margin: "0px 50px",
        "@media only screen and (max-width: 1500px)": {
            margin: "50px 0"
        },
        "& p": {
            color: "#0062e1",
            marginBottom: "10px",
            fontFamily: "Comfortaa, sans-serif",
        },
        "& h2": {
            color: "#333",
            fontSize: "30px",
            marginBottom: "10px",
            fontFamily: "Comfortaa, sans-serif",
        }
    },
    title: {
        backdropFilter: "blur(10px)",
        color: "#333",
        padding: "15px",
        background: "rgba(0, 98, 255, 0.1)",
        borderRadius: "10px 0",
        marginBottom: "20px"
    },
    link: {
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        border: "1px solid #0062e1",
        cursor: "pointer",
        transition: "0.4s",
        "&:hover": {
            background: "#0062e1",
            "& svg": {
                color: "#fff"
            }
        },
        "& svg": {
            width: "20px",
            height: "20px",
            color: "#0062e1",
            transition: "0.4s",
        }
    },
    img: {
        "& img": {
            position: "relative",
            height: "310px",
            objectFit: "cover",
            "@media only screen and (max-width: 1500px)": {
                width: "100%",
                height: "100%"
            },
        }
    },
    calendarh: {
        filter: "drop-shadow(0px 0 10px #299d8f)",
    },
    arispot: {
        filter: "drop-shadow(0px 0 10px #ff5a60)",
    },
    movia: {
        filter: "drop-shadow(0px 0 10px #000a15)",
    },
    simplifreelanceagency: {
        filter: "drop-shadow(0px 0 10px #3e3e9e)",
    },
    qendly: {
        filter: "drop-shadow(0px 0 10px #2e89ff)",
    },
    top: {
        "@media only screen and (max-width: 1500px)": {
            marginTop: "-35px"
        }
    },
    margin: {
        padding: "140px 30px"
    },
    show: {
        position: "fixed",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 99999,
        display: "none"
    },
    active: {
        display: "block"
    },
    style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh"
    },
    info: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "500px",
        background: "#fff",
        borderRadius: "15px",
        padding: "20px",
        margin: "10px",
        "& h1": {
            marginBottom: "20px"
        },
        "& p": {
            textAlign: "center",
            color: "#545F7E"
        },
    },
    button: {
        margin: "10px",
        padding: "10px 20px",
        borderRadius: "5px",
        outline: 0,
        border: "1px solid transparent",
        cursor: "pointer",
    },
    close: {
        borderColor: "#ff4d4d",
        background: "#fff",
        color: "#ff4d4d",
        transition: "0.4s",
        "&:hover": {
            color: "#fff",
            background: "#ff4d4d",
        }
    },
    open: {
        borderColor: "#28a745",
        background: "#28a745",
        color: "#fff",
        transition: "0.4s",
        "&:hover": {
            color: "#28a745",
            background: "#fff",
        }
    },
    bodyClass: {
        overflow: "hidden"
    }
});

export default useStyles;